module.exports = __webpack_public_path__ + "img/mhtit6.ca14fdef.png";